var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurntBean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bean-Blueprint",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_-Background"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "GA-01-Solid",
    x: 0,
    width: 1920,
    height: 1920
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-20.8 1140.05 180.69 807.59 206.42 985.71 681.45 299.76 681.45 797.3 1347.99 904.24 1758.39 291.18 1734.81 1367.27 1996.33 1034.69 2202.11 2130.4 -235.16 2153.98 -20.8 1140.05",
    style: {
      stroke: "#ff9829",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_-HeadSmall"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Outline",
    cx: 960,
    cy: 964.99,
    r: 459.38,
    style: {
      stroke: "#fff952",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_-Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Outline-2",
    d: "M792.17,1671.85c-69.11,0-125.66,56.39-125.66,125.5h0c0,69.11,56.55,125.66,125.66,125.66h335.66c69.11,0,125.66-56.55,125.66-125.66h0c0-69.11-56.55-125.48-125.66-125.48h0c69.11,0,125.66-56.4,125.66-125.52h0c0-69.11-56.55-125.66-125.66-125.66h-335.66c-69.11,0-125.66,56.55-125.66,125.66h0c0,69.11,56.55,125.5,125.66,125.5l335.66,.02",
    style: {
      stroke: "#fff952",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "GoodVibe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "GA-02-Solid",
    d: "M664.45,1174.67c-149.35,0-270.43-121.08-270.43-270.43s121.08-270.43,270.43-270.43,270.43,121.08,270.43,270.43-121.08,270.43-270.43,270.43Zm861.53-270.43c0-149.35-121.08-270.43-270.43-270.43s-270.43,121.08-270.43,270.43,121.08,270.43,270.43,270.43,270.43-121.08,270.43-270.43Z",
    style: {
      stroke: "#fff952",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eyes",
    d: "M645.87,1010.61l-21.94-8.52c-119.98-49.68-199.1-133.78-176.72-187.82,20.91-50.5,123.05-56.89,234.25-16.98l-35.59,213.32Zm644.54-228.8c-24.35,5.78-49.76,13.96-75.38,24.57-119.98,49.68-199.1,133.78-176.72,187.82,19.71,47.59,111.56,56.01,215.15,23.41l36.95-235.8Z",
    style: {
      stroke: "#fff952",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pupils",
    d: "M1472.79,814.27c22.38,54.05-56.74,138.14-176.72,187.82-14.32,5.93-28.58,11.09-42.62,15.51-21.35-27.78-34.06-62.56-34.06-100.31,0-56.16,28.11-105.75,71.01-135.49,89.65-21.29,164.78-10.04,182.38,32.47Zm-767.82-7.9c-7.87-3.26-15.72-6.28-23.52-9.08-36.6,30.22-59.92,75.94-59.92,127.11,0,31.61,8.91,61.13,24.34,86.21,111.81,40.54,214.81,34.33,235.83-16.41,22.38-54.05-56.74-138.14-176.72-187.82Z",
    style: {
      stroke: "#fff952",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Brows",
    d: "M842.4,807.59h-45.69c-9.77,0-17.77-8-17.77-17.77h0c0-9.77,8-17.77,17.77-17.77h45.69c9.77,0,17.77,8,17.77,17.77h0c0,9.77-8,17.77-17.77,17.77Zm298.66-17.77h0c0-9.77-8-17.77-17.77-17.77h-45.69c-9.77,0-17.77,8-17.77,17.77h0c0,9.77,8,17.77,17.77,17.77h45.69c9.77,0,17.77-8,17.77-17.77Z",
    style: {
      fill: "#fff952"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    d: "M986.35,1038.39l.1,.33c.9,2.91-.84,5.97-3.79,6.7-14.78,3.63-30.49,3.65-45.3,.06-2.96-.72-4.71-3.78-3.81-6.69l.1-.33c.83-2.69,3.62-4.22,6.36-3.55,13.06,3.16,26.93,3.14,39.97-.05,2.74-.67,5.53,.85,6.37,3.54Z",
    style: {
      fill: "#fff952"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-27.33 1762 443.42 1261.44 382.75 1867.89 725.44 1523.27 692.71 1964.15 -65.83 1983.4 -27.33 1762",
    style: {
      stroke: "#ff9829",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1123.97 1960.3 1370.4 1646.49 1364.51 1820.99 1645.38 1392.07 1576.43 1968.02 1805.59 1954.84 1940.45 1671.85 1969.85 1975.12 1388.84 2042.04 1123.97 1960.3",
    style: {
      stroke: "#ff9829",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1743.25-183.68c-82.38,0-156.85,18.47-210.38,48.25-32.66-23.45-74.74-37.58-120.66-37.58-87.27,0-160.65,50.99-181.91,120.14-78.3-48.45-225.23-81.07-393.58-81.07s-320.03,33.69-397.33,83.44c-49.57-49.75-145.09-83.44-254.8-83.44C23.9-133.94-106.37-61.67-106.37,27.48S23.9,188.9,184.59,188.9c109.71,0,205.23-33.69,254.8-83.44,77.3,49.75,226.25,83.44,397.33,83.44,194.01,0,359.57-43.33,424.43-104.27,34.29,39.56,89.18,65.2,151.06,65.2,53.89,0,102.48-19.44,136.78-50.6,51.9,24.86,119.86,39.93,194.27,39.93,162.97,0,295.08-72.27,295.08-161.42s-132.11-161.42-295.08-161.42Z",
    style: {
      stroke: "#f95353",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 12
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurntBean);
export default __webpack_public_path__ + "static/media/burnt_bean.7aa6a7b11ba9c7cefaf208c65622d4de.svg";
export { ForwardRef as ReactComponent };